import type { RootState } from '../types/store';
import getCurrentPackage from './current-package';
import getTopAvailableHostingPackage from './top-available-hosting-package';
import prioritizer from '../prioritizer';
import type { SubscriptionType } from '../types/subscription';
import messenger from '../messenger';

function getHostingUpgradeAvailability(state: RootState): boolean {
  const currentPackage = getCurrentPackage(state);
  const topAvailablePackage = getTopAvailableHostingPackage(state);

  if (!currentPackage) throw new Error(messenger.missingData('currentPackage'));

  return (
    prioritizer.getPriority(currentPackage.type as SubscriptionType) <
    prioritizer.getPriority(topAvailablePackage.type as SubscriptionType)
  );
}

export default getHostingUpgradeAvailability;
